<template>
  <d-modal
    class="modal-big"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('customer.contact.notifications') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="pt-0">
      <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center popup-overlay-loading">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <contact-notifications
        v-if="!loadError && allDataLoaded"
        class="mt-3"
        :notifications="notifications"
        :contactID="contactID"
        :contactType="contactType" />

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-modal-body>
  </d-modal>
</template>

<script>
import ContactNotifications from './ContactNotifications.vue';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'contact-notifications-popup',
  components: {
    'contact-notifications': ContactNotifications
  },
  props: [
    'contactID',
    'contactType'
  ],
  computed: {
    allDataLoaded () {
      return this.loadedData;
    }
  },
  data() {
    return {
      customer_id: null,
      customer_contact_id: null,
      loadedData: false,
      loadError: false,
      notifications: null,
    };
  },
  mounted () {
    this.loadItemData();
    this.$bus.$on('contact-notifications-reload-needed', this.reloadNotificationsView);
  },
  methods: {
    reloadNotificationsView () {
      this.loadedData = false;
      let endpointURL = '/contacts/item/';

      if (this.contactType === 'market') {
        endpointURL = '/market-customers/contacts/item/';
      }

      if (this.contactType === 'potential') {
        endpointURL = '/potential-customers/contacts/item/';
      }

      FormUtils.loadItemData(this, {
        endpointBase: endpointURL,
        overrideID: this.contactID,
        instanceFields: ['notifications'],
        loadedKey: 'loadedData',
        errorKey: 'loadError'
      });
    },
    loadItemData () {
      let endpointURL = '/contacts/item/';

      if (this.contactType === 'market') {
        endpointURL = '/market-customers/contacts/item/';
      }

      if (this.contactType === 'potential') {
        endpointURL = '/potential-customers/contacts/item/';
      }

      FormUtils.loadItemData(this, {
        endpointBase: endpointURL,
        overrideID: this.contactID,
        instanceFields: ['notifications'],
        loadedKey: 'loadedData',
        errorKey: 'loadError'
      });
    },
    handleClose () {
      this.$bus.$emit('close-contact-notifications-popup');
    },
    cancel () {
      this.handleClose();
    }
  },
  beforeDestroy () {
    this.$bus.$off('contact-notifications-reload-needed', this.reloadNotificationsView);
  }
};
</script>

<style lang="scss">
.tabs-in-modal .nav-tabs .nav-link {
  background-color: #F5F6F8;

  &.active {
    background-color: #FFF;
  }
}
</style>
